module.exports = "/fonts/NunitoSans-Regular.cd66294b855b9fc2ae182eaae9891f84.ttf";